import type { FC, ReactNode } from 'react';

import { Box, DialogPreset, List, type DialogPresetProps } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import { FilterListMobileItem } from '../FilterListMobileItem';

export const FilterSelectionDialogMobileFragment = graphql(/* GraphQL */ `
  fragment FilterSelectionDialogMobileFragment on SearchFilterBase {
    id
    ...FilterListMobileItemFragment
  }
`);

export type FilterSelectionDialogMobileProps = Pick<
  DialogPresetProps,
  'title' | 'open' | 'onClose' | 'onBack' | 'applyCloseButtonPaddingWorkaround'
> & {
  maskedDataItems: FragmentType<typeof FilterSelectionDialogMobileFragment>[];
  /** Ids of all currently used filters
   * @default []
   */
  currentlyActiveFilterIds?: string[];
  /** Callback fired when an individual filter is selected */
  onSelect?: (filterId: string) => void;
  children?: ReactNode;
};

/**
 * A dialog to select a filter on mobile
 * */
export const FilterSelectionDialogMobile: FC<FilterSelectionDialogMobileProps> = ({
  title,
  maskedDataItems,
  open,
  currentlyActiveFilterIds = [],
  onSelect,
  onClose,
  onBack,
  applyCloseButtonPaddingWorkaround,
  children,
}) => {
  const availableFilters = maskedDataItems.map((maskedData) =>
    getFragmentData(FilterSelectionDialogMobileFragment, maskedData),
  );

  return (
    <DialogPreset
      title={title}
      open={open}
      onBack={onBack}
      onClose={onClose}
      applyCloseButtonPaddingWorkaround={applyCloseButtonPaddingWorkaround}
    >
      <Box sx={{ overflow: 'auto' }}>
        <List>
          {availableFilters.map((filter) => (
            <FilterListMobileItem
              maskedData={filter}
              isActive={currentlyActiveFilterIds.includes(filter.id)}
              onClick={onSelect}
            />
          ))}
          {children}
        </List>
      </Box>
    </DialogPreset>
  );
};
